import { render, staticRenderFns } from "./PlatformTotal.vue?vue&type=template&id=32070d88&"
import script from "./PlatformTotal.vue?vue&type=script&lang=js&"
export * from "./PlatformTotal.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTotal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports